import Image from 'next/image'
import Router from 'next/router'
import { ComponentPropsWithoutRef } from 'react'
import { useClient } from 'urql'

import { graphql } from '@/partner-gql'
import { logout } from '@/partner-urql'
import { getAuthentication } from '@/urql-common'
import { cn } from '@/utils/tw-helpers'

import { PartnerTopHeaderMenu } from './PartnerTopHeaderMenu'

interface PartnerWebTopHeaderProps extends ComponentPropsWithoutRef<'header'> {
  title?: string
  showRight?: boolean
  /** Partner name to display in the header menu */
  partnerName: string
}

const PartnerSignOutMutation = graphql(`
  mutation PartnerSignOutMutation($refreshToken: String!) {
    signOut(input: { refreshToken: $refreshToken }) {
      errors {
        ... on ValidationError {
          field
          message
        }
      }
    }
  }
`)

export const PartnerWebTopHeader = (props: PartnerWebTopHeaderProps): JSX.Element => {
  const { showRight = true, partnerName, className, ...rest } = props

  const client = useClient()
  const isAuthenticated = getAuthentication()

  const handleSignOutClick = async function () {
    const refreshToken = getAuthentication()?.refreshToken
    if (!refreshToken) return

    await client.mutation(PartnerSignOutMutation, { refreshToken }).toPromise()
    await logout()
  }

  return (
    <header
      className={cn(
        'flex h-[50px] items-center bg-white px-2 md:h-[60px] md:px-3 lg:h-[70px] lg:px-6',
        className
      )}
      {...rest}
    >
      <div className="md:flex-1">
        <Image
          src="/gApp_logo.svg"
          width={196}
          height={52}
          alt="LogiQlabo"
          className="h-8 w-[120px] md:h-10 md:w-[150px] lg:h-[52px] lg:w-[196px]"
        />
      </div>
      <div className="flex-1">
        {!!props.title && (
          <h2 className="text-center text-lg font-bold text-[#A2A2A2]">{props.title}</h2>
        )}
      </div>
      <div className="flex flex-1 justify-end">
        {showRight &&
          (isAuthenticated ? (
            <PartnerTopHeaderMenu
              partnerName={partnerName}
              handleSignOutClick={handleSignOutClick}
            />
          ) : (
            <button
              className="g-button g-button--primary !h-[44px] w-[130px] !rounded-full !text-sm !shadow-none"
              onClick={() => Router.push('/web/partner-admin/sign_in')}
            >
              ログイン
            </button>
          ))}
      </div>
    </header>
  )
}
